export const DEFAULT_PANEL_WIDTH = 280;
export const DEFAULT_DETAIL_PANEL_WIDTH = 400;
